var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataList),function(ref){
var tag_id = ref.tag_id;
var tag_name = ref.tag_name;
return _c('el-button',{key:tag_id,attrs:{"size":"mini","round":""},on:{"click":function (e) { return _vm.tagClick(e, tag_name, tag_id); }}},[_vm._v(" #"+_vm._s(tag_name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }